import { Instance } from 'mobx-state-tree';
import { AuthDtoModelBase } from './AuthDtoModel.base';

/* The TypeScript type of an instance of AuthDtoModel */
export interface AuthDtoModelType extends Instance<typeof AuthDtoModel.Type> {}

/* A graphql query fragment builders for AuthDtoModel */
export { selectFromAuthDto, authDtoModelPrimitives, AuthDtoModelSelector } from './AuthDtoModel.base';

/**
 * AuthDtoModel
 */
export const AuthDtoModel = AuthDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
